<style lang="scss" scoped>
</style>

<template>
    <div>
        <vue-stars :name="'demo' + _uid" active-color="#f2644a" :inactive-color="icolor" shadow-color="transparent" hover-color="#f2644a" :max="5" :min="0" v-model="localCount" :readonly="readonly" char="★" inactive-char="☆" />
        <span v-if="showCount" class="text-primary fs-12 ml-15">{{ total }} {{ $t('states.ratings') }}</span>
    </div>
</template>

<script>
import VueStars from "vue-stars";
export default {
    components: { VueStars },
    props: {
        /**
         * Number defining the rating value
         * @type {Number}
         */
        total: {
            type: Number,
            default: 0
        },

        /**
         * Number defining the total amount of ratings
         * @type {Number}
         */
        count: {
            type: Number,
            default: 0
        },

        /**
         * Boolean defining if the rating is readOnly
         * @type {Boolean}
         */
        readonly: {
            type: Boolean,
            default: true
        },

        /**
         * Boolean defining if the count should be shown
         * @type {Boolean}
         */
        showCount: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            localCount: this.count
        };
    },
    computed: {
        icolor() {
            if (this.readonly) return "#f2644a";
            else return "#e3eaee";
        }
    },
    watch: {
        localCount: function() {
            this.$emit("updated", this.localCount);
        }
    }
};
</script>
